/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_avatar_requires_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires linked account`)
};

const zh_hans1_settings_avatar_requires_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要已绑定账号`)
};

const zh_hant1_settings_avatar_requires_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要已綁定帳戶`)
};

const fr_settings_avatar_requires_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte lié requis`)
};

const de_settings_avatar_requires_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpftes Konto erforderlich`)
};

const ja_settings_avatar_requires_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携アカウントが必要`)
};

const ko_settings_avatar_requires_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결된 계정 필요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_avatar_requires_linked = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_avatar_requires_linked(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_avatar_requires_linked", locale)
	if (locale === "en") return en_settings_avatar_requires_linked(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_avatar_requires_linked(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_avatar_requires_linked(inputs)
	if (locale === "fr") return fr_settings_avatar_requires_linked(inputs)
	if (locale === "de") return de_settings_avatar_requires_linked(inputs)
	if (locale === "ja") return ja_settings_avatar_requires_linked(inputs)
	return ko_settings_avatar_requires_linked(inputs)
};